import { toast } from "react-hot-toast";

// Show a success toast
export function toastSuccess(message = "Success") {
  toast.success(message);
}

// Show an error toast
export function toastError(message = "Something went wrong") {
  toast.error(message);
}

// Show a loading toast (returns toast ID)
export function toastLoading(message = "Loading...") {
  return toast.loading(message);
}

// Dismiss a toast by ID or all if no ID passed
export function toastDismiss(toastId) {
  if (toastId) {
    toast.dismiss(toastId);
  } else {
    toast.dismiss();
  }
}

// Show a custom component toast
export function toastCustom(component, options = {}) {
  toast.custom(component, options);
}

export const toastOptions = {
  duration: 3000,
  style: {
    background: "#fff",
    color: "#333",
    padding: "12px 16px",
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    fontSize: "14px"
  },
  success: {
    style: {
      background: "#e6ffed",
      color: "#036d19"
    }
  },
  error: {
    style: {
      background: "#ffeaea",
      color: "#b30000"
    }
  }
};
